import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import Spinner from "../../primitives/Spinner/Spinner";
import { colorOf, sizeOf } from "../../utils/propTypes";
import css from "./FAB.module.css";

const FAB = React.forwardRef(
  (
    {
      variant = "standard",
      size = "md",
      disabled = false,
      loading = false,
      color = "primary-container",
      icon,
      label,
      className,
      onClick,
      children,
      ...rest
    },
    ref,
  ) => {
    const isExtended = variant === "extended";
    const isDisabled = disabled || loading;

    const classes = clsx(
      css.root,
      isExtended ? css.extended : css[size],
      css[`color-${color}`],
      className,
    );

    return (
      <button
        ref={ref}
        type="button"
        className={classes}
        disabled={isDisabled}
        aria-busy={loading || undefined}
        aria-label={!isExtended && !loading ? label : undefined}
        onClick={onClick}
        {...rest}
      >
        {loading ? (
          <Spinner size="sm" label="Loading…" />
        ) : (
          <>
            <span className={css.icon}>{icon || children}</span>
            {isExtended && label && <span className={css.label}>{label}</span>}
          </>
        )}
      </button>
    );
  },
);

FAB.displayName = "FAB";

FAB.propTypes = {
  variant: PropTypes.oneOf(["standard", "extended"]),
  size: sizeOf("sm", "md", "lg"),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  color: colorOf(
    "primary-container",
    "surface",
    "secondary-container",
    "tertiary-container",
  ),
  icon: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default FAB;
